import defaultUser from "../utils/default-user";
import axios from "axios";
import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export async function signIn(email, password) {
  try {
    const response = await axios.post(
      `${apiUrl}/api/login/`,
      { email, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.status === 200) {
      return {
        isOk: true,
        data: response.data,
      };
    }
  } catch (err) {
    return err.response?.data?.detail ===
      "OTP verification pending for customer. Please verify OTP to generate token."
      ? {
          isOk: false,
          message:
            "Email verification is pending! Please contact the admin to complete the verification process.",
        }
      : { isOk: false, message: err?.response?.data?.detail };
  }
}

async function getNewAccessToken() {
  try {
    const sessStoredAuth = JSON.parse(sessionStorage.getItem("authState"));
    const { refresh_token } = sessStoredAuth;

    const response = await axios.post(`${apiUrl}/api/token/refresh/`, {
      refresh_token: refresh_token,
    });

    if (response.status === 200) {
      return {
        isOk: true,
        data: {
          access_token: response.data.access_token,
        },
      };
    } else {
      sessionStorage.removeItem("authState");
      return false;
    }
  } catch (error) {
    return false;
  }
}

async function checkAuthentication() {
  const storedAuthSession = JSON.parse(sessionStorage.getItem("authState"));
  if (
    storedAuthSession?.email != null &&
    storedAuthSession?.userrole != null &&
    storedAuthSession?.access_token != null
  ) {
    try {
      const response = await axiosInstance.get(`${apiUrl}/api/secure/`, {
        headers: {
          Authorization: `Bearer ${storedAuthSession.access_token}`,
        },
      });
      if (response.status == 200) {
        return true;
      }
      return false;
    } catch (error) {
      if (error.response.status === 403) {
        const getNewToken = await getNewAccessToken();
        if (getNewToken.isOk) {
          const myNewToken = getNewToken.data.access_token;
          let authState = JSON.parse(sessionStorage.getItem("authState"));
          authState.access_token = myNewToken;

          const updatedAuthState = JSON.stringify(authState);
          sessionStorage.setItem("authState", updatedAuthState);
          return true;
        }
      }
      return false;
    }
  } else {
    return false;
  }
}

// export async function getUser() {
//   try {
//     let storedAuthSession = JSON.parse(sessionStorage.getItem("authState"));

//     if (!storedAuthSession) {
//       const localAuth = JSON.parse(localStorage.getItem("authState"));

//       if (localAuth) {
//         const currentTime = new Date().getTime();

//         if (localAuth.expirationTime > currentTime) {
//           // Restore session
//           sessionStorage.setItem("authState", JSON.stringify(localAuth));
//           storedAuthSession = localAuth;
//         } else {
//           // Expired → cleanup
//           localStorage.removeItem("authState");
//         }
//       }
//     }

//     if (await checkAuthentication()) {
//       if (storedAuthSession.email) {
//         const currentTime = new Date().getTime();
//         if (storedAuthSession.expirationTime >= currentTime) {
//           return {
//             isOk: true,
//             data: {
//               ...storedAuthSession,
//             },
//           };
//         } else {
//           sessionStorage.removeItem("authState");
//           return {
//             isOK: false,
//           };
//         }
//       }
//     }
//     return {
//       isOk: false,
//       data: {},
//     };
//   } catch {
//     return {
//       isOk: false,
//     };
//   }
// }

export async function getUser() {
  try {
    const storedAuth = JSON.parse(sessionStorage.getItem("authState"));

    if (!storedAuth) {
      return { isOk: false };
    }

    const currentTime = Date.now();

    if (storedAuth.expirationTime < currentTime) {
      sessionStorage.removeItem("authState");
      localStorage.removeItem("authState");
      return { isOk: false };
    }

    return {
      isOk: true,
      data: storedAuth,
    };
  } catch {
    return { isOk: false };
  }
}

export async function createAccount(email, password) {
  try {
    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to create account",
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to change password",
    };
  }
}

export async function resetPassword(email) {
  try {
    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to reset password",
    };
  }
}
